import { useEffect } from "react";

import { useUserMedia, useUserMediaPreviewStreamConsumer } from "../../hooks/useUserMedia";

export default function useUserMediaSetup({ inMeetingDetailsRoute, store }) {
  const { previewStream } = useUserMediaPreviewStreamConsumer(
    (inMeetingDetailsRoute && store.meeting?.status === "started") ||
      (store.isJoined && store.meeting?.status === "started") ||
      ((store.isJoined || store.isJoining) && store.userMediaPermissionsGranted),
  );
  const { stopPreviewMicStream } = useUserMedia();

  useEffect(() => {
    let isCancelled = false;
    const requestMediaPermissions = async () => {
      if (!store.isJoining && !store.isJoined && !store.userMediaPermissionsGranted && previewStream) {
        try {
          stopPreviewMicStream();
          store.setIsUserMediaPermissionsGranted(true);
        } catch (error) {
          console.error("Error requesting user media permissions", error);
          store.setIsUserMediaPermissionsGranted(false);
        }
      }
    };

    if (!isCancelled && inMeetingDetailsRoute && store.meeting?.status === "started") {
      requestMediaPermissions();
    }

    return () => {
      isCancelled = true;
    };
  }, [
    inMeetingDetailsRoute,
    store.isJoining,
    store.isJoined,
    store.userMediaPermissionsGranted,
    store.meeting,
    previewStream,
    stopPreviewMicStream,
    store,
  ]);
}
